import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  Container,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import { ArrowBack, ArrowForwardIos } from '@mui/icons-material';
import { Link, Redirect } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { ROUTING_CONFIG, supportArticleRoute, supportCategoryRoute } from '@uplift/constants';
import { Button, ProviderLayout, ProviderLayoutPageHeader, ProviderLayoutPageTitle } from '@uplift/ui-v2';
import { getSupportCategory } from './articles';

const useStyles = makeStyles({ name: 'SupportCategoryPage' })(theme => ({
  content: {
    maxWidth: 900,
    margin: '0 auto',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
  },
  description: {
    marginBottom: theme.spacing(3),
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
  articleCard: {
    border: `1px solid ${theme.palette.primary.background}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0px 4px 14px 0px rgba(0,0,0,0.05)',
    width: '100%',
  },
  articleAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
  },
  chevron: {
    color: theme.palette.secondary.main,
    flexShrink: 0,
  },
}));

export const SupportCategoryPage = () => {
  const { category } = supportCategoryRoute.useParams();
  const group = getSupportCategory(category);
  const { classes } = useStyles();

  if (!group) {
    return <Redirect to={ROUTING_CONFIG.support} />;
  }

  return (
    <ProviderLayout>
      <ProviderLayoutPageHeader
        title={(
          <Box>
            <Button
              component={Link}
              to={ROUTING_CONFIG.support}
              color="secondary"
              startIcon={<ArrowBack />}
              sx={{ mb: 1, px: 0 }}
            >
              Back to Help Center
            </Button>
            <ProviderLayoutPageTitle title={group.label} />
          </Box>
        )}
      />
      <Container className={classes.content}>
        <Typography variant="body1" color="textSecondary" className={classes.description}>
          {group.description}
        </Typography>
        <List className={classes.list} disablePadding>
          {group.articles.map(article => (
            <ListItem key={article.slug} className={classes.listItem} disableGutters>
              <Card className={classes.articleCard}>
                <CardActionArea
                  component={Link}
                  to={supportArticleRoute.createLink({ slug: article.slug })}
                  className={classes.articleAction}
                >
                  <Typography variant="subtitle1">
                    {article.title}
                  </Typography>
                  <ArrowForwardIos fontSize="small" className={classes.chevron} />
                </CardActionArea>
              </Card>
            </ListItem>
          ))}
        </List>
      </Container>
    </ProviderLayout>
  );
};
